import PropTypes from 'prop-types';
import React from 'react';
import StarRatingBase from './StarRatingBase';

const StarRating = (props) => {
    const {rating, size, ...rest} = props;

    return (
        <StarRatingBase rating={rating} size={size} {...rest} />
    );
};

StarRating.propTypes = {
    /** Raw Rating Number.  StarRating will round to the correct half star. */
    rating: PropTypes.number.isRequired,
    /** The StarRating size variation. The value corresponds to the px height of the stars. 'sm' and 'lg' are deprecated and map to 12 and 24 respectively. */
    size: PropTypes.oneOf(['12', '16', 'lg', 'sm'])
};

export default StarRating;
